import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClick", "onKeyup", "title"]
const _hoisted_2 = { lang: "ja" }
const _hoisted_3 = ["rowspan"]
const _hoisted_4 = { class: "text-uppercase" }

import { ref, computed } from 'vue';

// Stores
import { useUiStore } from '@stores/ui';

// Personal components
import QPageTitle from '@components/QPageTitle.vue';
import DialogProgramDetail from '@components/dialog/program/DialogProgramDetail.vue';

// Personal libs
import { IProgram, IVideo } from '@shared/interface/model.interface';
import { $t } from 'src/i18n/utils';
import { ProgramDto } from '@data/dto/program-dto';
import { UpdateManagerProgram } from '@shared/service/updateManager/update-manager-program.service';
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum';
import { VideoStatusEnum } from '@shared/enum/video-status.enum';

/**
 * Stores
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgramsPage',
  setup(__props) {

// Vendor
const uiStore = useUiStore();

/**
 * Reactive data
 */
// const programs = ref<Array<IProgram> | undefined>([]);
const showDetailsDialog = ref<boolean>(false);
const selectedProgram = ref<IProgram>(new ProgramDto());

/**
 * Computed data
 */
const programs = computed<IProgram[]>(() => uiStore.programs ?? []);

/**
 * Methods
 */
function defineBackgroundClass(program: IProgram): string {
  return `belt-${program.beltCode}-${program.gradeLevel}`;
}

function defineIconViewColor(program: IProgram): string {
  if ([8, 7, 6, 5, 3, 2].includes(program.gradeOrder ?? 0)) {
    return 'black';
  } else {
    return 'white';
  }
}

function defineRowpan(program: IProgram): number {
  const threeLines = [8];
  const fourLines = [7, 6, 5, 2, 1];
  const fiveLines = [4, 3];

  if (program.isKyu === true && program.programOrder === 1) {
    if (threeLines.includes(program.gradeOrder ?? 0)) {
      return 3;
    } else if (fourLines.includes(program.gradeOrder ?? 0)) {
      return 4;
    } else if (fiveLines.includes(program.gradeOrder ?? 0)) {
      return 5;
    } else {
      return 0;
    }
  } else if (program.isDan && program.programOrder === 1) {
    return 7;
  } else {
    return 0;
  }
}

function displayAsterik(videos?: Array<IVideo>): string {
  return videos != null &&
    videos.filter((v) => v.status === VideoStatusEnum.VALIDATED).length > 0
    ? '*'
    : '';
}

function displayProgram(prog: IProgram) {
  selectedProgram.value = prog;
  showDetailsDialog.value = true;
}

function closeDialogProgramDetail() {
  showDetailsDialog.value = false;
}

/**
 * Init datas
 */
new UpdateManagerProgram.ProgramAll().exec(
  RepositoryStrategyEnum.NETWORK_FIRST,
);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QPageTitle, { title: 'Grades de Kobudo' }),
    _cache[4] || (_cache[4] = _createElementVNode("span", {
      id: "q-table-grades-caption",
      class: "hidden"
    }, " Grades de Kobudo avec les programs ", -1 /* HOISTED */)),
    _createVNode(_component_q_markup_table, {
      square: "",
      dense: "",
      flat: "",
      class: "markup-table q-mx-none",
      "aria-describedby": "q-table-grades-caption"
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("caption", { class: "sr-only" }, [
          _createElementVNode("span", null, "Tableau des programmes par ceinture."),
          _createElementVNode("span", null, " Les programmes possédant une vidéo sont suffixés par un astérisque (*) ")
        ], -1 /* HOISTED */)),
        _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-primary" }, [
          _createElementVNode("tr", { class: "text-h5 q-ml-md text-white bg-primary" }, [
            _createElementVNode("th", {
              id: "program",
              class: "col1 text-left word-wrap"
            }, [
              _createElementVNode("span", { class: "text-uppercase" }, "programme"),
              _createElementVNode("span", {
                "aria-hidden": "true",
                class: "q-ma-none q-pa-none",
                style: {"font-size":"0.8em"}
              }, " (* : vidéo disponible) ")
            ]),
            _createElementVNode("th", {
              id: "belt",
              class: "col2 text-center word-wrap text-uppercase"
            }, " Ceinture ")
          ])
        ], -1 /* HOISTED */)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programs.value, (program, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass(defineBackgroundClass(program))
            }, [
              _createCommentVNode(" program label "),
              _createElementVNode("td", {
                headers: "program belt_color",
                class: "text-left word-wrap text-weight-medium text-uppercase cursor-pointer set-outline-offset",
                onClick: ($event: any) => (displayProgram(program)),
                onKeyup: _withKeys(($event: any) => (displayProgram(program)), ["enter"]),
                title: 'Voir les détails du program ' + program.label,
                tabindex: "0"
              }, [
                _createCommentVNode(" Voir les détails "),
                _createVNode(_component_q_icon, {
                  name: "visibility",
                  size: "sm",
                  color: defineIconViewColor(program),
                  class: "cursor-pointer q-mr-sm"
                }, null, 8 /* PROPS */, ["color"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(program.label), 1 /* TEXT */),
                _createTextVNode(" " + _toDisplayString(displayAsterik(program?.videos)), 1 /* TEXT */)
              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
              _createCommentVNode(" Belt "),
              (defineRowpan(program) > 0)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 0,
                    id: "belt_color",
                    rowspan: defineRowpan(program),
                    class: "text-center text-weight-medium"
                  }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref($t)(`generic.beltLabel.${program.beltCode}`)), 1 /* TEXT */),
                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                    _createElementVNode("span", null, _toDisplayString(program?.gradeOrder) + "e " + _toDisplayString(program?.isKyu ? 'Kyu' : 'Dan'), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_3))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Dialog : program details "),
    _createVNode(DialogProgramDetail, {
      show: showDetailsDialog.value,
      program: selectedProgram.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (closeDialogProgramDetail()))
    }, null, 8 /* PROPS */, ["show", "program"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})